module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "pag_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  }), _vm._v(" 1 "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pag_1"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The day the box came started out like any other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I opened up the Pork Pit, the barbecue restaurant that I ran in downtown Ashland, right on schedule. Turned on the appliances, tied a blue work apron on over my clothes, and flipped the sign on the front door over to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Open")]), _vm._v(". Then I spent the rest of the morning and on into the afternoon cooking up burgers, baked beans, and the thick, hearty barbecue sandwiches that my gin joint was so famous for. In between filling orders, I chatted with the waitstaff, wiped down tables, and made sure that my customers had everything they needed to enjoy their hot, greasy meals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All the while, though, I kept waiting for someone to try to kill me.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pag_1"
    }
  }, [_vm._v("Not for the first time today, my gaze swept over the storefront, which featured an assortment of tables and chairs, along with blue and pink vinyl booths. Matching, ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("faded, peeling pig tracks on the floor led to the men’s and women’s bathrooms, respectively. A long counter with padded stools ran along the back wall of the restaurant.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Since it was after six, the dinner rush was on, and almost every seat was taken. The waitstaff bustled back and forth, taking orders, fetching food, and topping off drinks, and the "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("clink-clank")]), _vm._v(" of dishes filled the restaurant, along with the steady "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("scrape-scrape-scrape")]), _vm._v(" of forks, knives, and spoons on plates and bowls. Murmurs of more than a dozen different conversations added to the pleasant mix of sounds, while the rich, hearty smells of cumin, black pepper, and other spices tickled my nose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Everything was as it should be, but I still looked at first one diner, then another. A few folks swallowed and quickly glanced away when they realized that I was watching them, not daring to meet my gaze for more than a second. But most were happily focused on their food and their companions and paid me no more attention than they should have. They were just here for the Southern treats the restaurant served up—not to try to murder me and cash in on my reputation as the Spider, Ashland’s most notorious assassin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gin?” A deep male voice cut into my latest examination of the storefront and its occupants.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("I looked over at the man perched on the stool closest to the cash register. Despite his slightly crooked nose and a scar that cut across his chin, he was ruggedly handsome, with intense violet eyes and black hair shot through with blue highlights. His navy business suit and white shirt highlighted the coiled strength in his chest and shoulders, ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("and I wasn’t the only woman who paused to give him an admiring glance.")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is everything okay?” Owen Grayson, my lover, asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My eyes cut left and right one more time before I answered him. “Seems to be. For the moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Owen nodded and went back to his meal, while I grabbed a rag and started wiping down the counter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Actually, so far, the afternoon had passed in a perfectly normal fashion, with the glaring exception that no one had tried to murder me—yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thinking that I might actually get through the workday unscathed for a change, I let myself relax, at least until the bell over the front door chimed. I glanced over at the entrance, expecting to see some new customers ready, willing, and eager to get their barbecue on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only this wasn’t a customer—it was a short, thin man wearing a delivery uniform of black boots and matching coveralls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guy glanced around the storefront for a minute before his eyes locked on me, and he headed in my direction. I tensed, eyeing the long white box in his hand, and dropped my right arm down behind the counter out of sight. A second later, a knife slid into my hand, one of five weapons that I had hidden on me. This wasn’t the first time someone had dressed up like a deliveryman to try to get close to me at the restaurant. The last guy was still in the cooler out back, awaiting the skills of Sophia Deveraux, the head cook at the Pork Pit, who also moonlighted as my own personal body disposer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the guy stepped right up to the cash register, as though this was a simple delivery.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("“I’ve got a package here for Gin Blanco,” he said in a bored voice. “Is that you?”")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here. Sign this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He shoved an electronic scanner at me. I slid my knife into a slot below the cash register, where it would still be out of sight, and took the device from him. The man waited while I used the attached pen to scrawl something that sort of looked like my signature onto the screen. The second I was done, the guy snatched the scanner away from me and shoved the white box into my hands at the same time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He tipped his head at me. “Have a nice day.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He started to walk away, but I reached out and latched onto his arm. The guy stopped, looked at me over his shoulder, and frowned, as if I’d violated some sort of secret delivery-guy protocol by touching him. Maybe I had.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?” he asked. “You need something else?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I carefully set the box down on the counter. The seat next to Owen was empty, so I was able to slide it several precious inches away from us. “What’s in the box?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guy shrugged. “I don’t know, and I don’t care. I just deliver ’em. I don’t look inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He started to pull away, but I tightened my grip on his arm. “You should really tell me what’s in the box.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He rolled his eyes. “And why should I do that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So I can be sure that there’s nothing . . . nasty inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Confusion filled his face. “Nasty? Why would you think that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, I don’t know,” I drawled. “Why don’t you check the name on the delivery order again?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("He glanced down at his scanner and hit a button on the device. “Yeah, it says deliver to Gin Blanco, care of the Pork Pit restaurant, downtown Ashland. So what? Is that supposed to mean something to me—”")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Comprehension dawned in his eyes as he finally recognized my name and realized who and what I really was. Gin Blanco. Restaurant owner. And, most important, the assassin the Spider.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He swallowed, his Adam’s apple bobbing up and down in his throat. “Look, I don’t want any trouble, lady. I’m just a delivery guy. I don’t know what’s in the box, and that info’s not on my scanner. I swear.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I kept my grip on his arm, staring into his eyes, but I didn’t see anything but a burning desire to get away from me as fast as he could. Smart man. Still, I let him sweat a few more seconds before I released his arm. “Okay. You can go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guy whipped around. He had started to take a step forward when I called out to him again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Wait. One more thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He froze. He teetered on his feet, and I could almost see the wheels spinning in his mind as he debated making a break for the door. But he must have realized how foolish that would make him look, because he finally turned and faced me again. I crooked my finger at him. The guy swallowed again, but he eased back over to me, although he made sure to stay out of arm’s reach and keep the cash register between us. Very smart man.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("By this point, my words and actions had attracted the attention of a few of the customers, who stared at me with wide eyes, as if I were going to whip out a knife and ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("slice open the delivery guy right in front of them. Please. I preferred to be a little more discreet about such things, if only to keep up appearances.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I stared at the delivery guy for a few more seconds before reaching down and grabbing something just below the cash register. He swallowed a third time, and beads of sweat had formed on his forehead, despite the restaurant’s air-conditioning. I raised my hand, and he tensed up more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reached up and tucked a hundred-dollar bill into the pocket on the front of his coveralls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Have a nice day,” I said in a sweet voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The guy stared at me, his mouth gaping open, as if he couldn’t believe that I was sending him on his way without so much as a scratch on him. But he quickly got with the program. He nodded at me, his head snapping up and down, as he backed toward the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Y’all come back now,” I called out. “Sometime when you have a chance to sit down and eat. The food here is terrific, in case you hadn’t heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The delivery guy didn’t respond, but he kept his eyes on me until his ass hit the doorknob. Then he gulped down a breath, threw the door open, and dashed outside as fast as he could without actually running.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Owen raised an eyebrow at me. “I think you about gave that poor guy a heart attack.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A grin curved my lips. “Serves him right for not being able to tell me what was in the package.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His gaze flicked to the white box sitting off to the side. “You going to open that?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("“Later,” I murmured. “When we’re alone. If there is ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("something nasty inside, there’s no use letting everyone see it.”")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“And if it’s not something nasty?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I snorted. “Then I’ll be pleasantly surprised. I’m not holding my breath about it, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_vm._v("•  •  •")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Owen finished his cheeseburger and onion rings and had a piece of cherry pie with vanilla bean ice cream for dessert, while I spent the next hour working. Slicing up more potatoes for the last of the day’s French fries. Checking on the pot of Fletcher’s secret barbecue sauce that was bubbling away on one of the back burners. Refilling drinks and ringing up orders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I also took the package into the back and placed it in one of the freezers. I didn’t know what surprises the box might contain, but I didn’t want my staff or customers to get injured by whatever might be lurking inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, around seven o’clock, the last of the customers paid up and left, and I decided to close the restaurant early for the night. I sent Sophia and the waitstaff home, turned off all the appliances, and flipped the sign over to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Closed")]), _vm._v(" before locking the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now all that was left to do was open the box.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I carefully pulled it out of the freezer, took it into the storefront, and put it down on the counter in the same spot as before. I made Owen move to the other side of the restaurant, well out of range of any elemental Fire or other magic that might erupt from it. Then I bent down and peered at the package.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("A shipping order was taped to the top, with my name and the Pork Pit’s address. But there was nothing on the ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("slip of paper to tell me who might have sent the box or where it had come from. All of that information had been left blank, which only made me more suspicious about what might be inside.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("And the box itself didn’t offer any more clues. It was simply a sturdy white box, long, rectangular, and about nine inches wide. No marks, runes, or symbols decorated the surface, not even so much as a manufacturer’s stamp to tell me who had made the box. I hesitated, then put my ear down close to the top and listened, in case someone had decided to put a bomb with an old-fashioned clock "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("tick-tick-tick")]), _vm._v("ing away inside. Stranger things had happened in my line of work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But no sounds escaped from the container. No smells either, and I didn’t sense any elemental magic emanating from it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anything?” Owen asked from his position by the front door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I shook my head. “Nothing so far.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lid of the box had been taped down, so I palmed one of my knives and sliced through the material, careful not to jiggle the package any more than necessary. Then I waited, counting off the seconds in my head. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Ten . . . twenty . . . thirty . . . forty-five . . . sixty . . .")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After two minutes had passed, I was reasonably sure that nothing would happen until I actually "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("opened")]), _vm._v(" the box.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Here goes nothing,” I called out to Owen.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("I slowly drew the top off the box and reached for my Stone magic, using it to harden my skin, head, hair, eyes, and any other part of me that might get caught in a blast ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("from a bomb or any rune trap that might be hidden inside. A sunburst rune that would make elemental Fire explode in my face, a saw symbol that would send sharp, daggerlike needles of Ice shooting out at me, maybe even some sort of Air elemental cloud design that would suck all of the oxygen away from me and suffocate me on the spot.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("But none of those things happened, and all I saw was a thick layer of white tissue paper wrapped around whatever was inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I carefully pushed one side of the paper out of the way, then the other, still holding on to my Stone power to protect myself from any possible problems. But to my surprise, the box held something innocuous after all: flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roses, to be exact—black roses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I let go of my magic, my skin reverting back to its normal soft texture, and frowned, wondering who would send me roses. I picked up one of the flowers, mindful of the sharp, curved thorns sticking out from the stem, and turned the blossom around and around, as if it held some sort of clue that would tell me who had sent it and why.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And it did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Because this wasn’t your typical rose. The stem was a milky white instead of the usual green, while the thorns were the same pale shade. But really, it was the petals that caught my attention, because they weren’t black so much as they were a deep, dark, vivid blue, a color that I’d only seen one place before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All clear,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Owen stepped over to the counter and looked into the box. “Roses? Somebody sent you roses?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("“It looks that way,” I murmured.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A white card was lying on top of the flowers, and I picked it up. Only two words were scrawled across the front in black ink and tight, cursive handwriting: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Happy anniversary")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That was it. That was all the card said, and no other marks, runes, or symbols decorated the stationery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I rubbed my fingers over the card. Not what I had expected it to say. Some sort of death threat would have been far more appropriate. Then again, I hadn’t thought that I’d get a package like this today either. But most troublesome was the fact that the two simple words gave me no clue to the writer’s tone, state of mind, or true meaning. The card, the message, the roses could have been anything from a simple greeting to the most biting sort of sarcasm. If I was betting, though, I’d put my money on sarcasm. Or perhaps a warning. Maybe even a promise of payback, retribution, revenge.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Happy anniversary?” Owen asked, peering at the card. “Anniversary of what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I glanced to the left at the calendar that I’d tacked up on the wall near the cash register. August twenty-fifth. It had happened ten years ago to the day. Funny, but right now, it seemed like ten minutes ago, given how hard my heart was hammering in my chest. I breathed in, trying to calm myself, but the sweet, sickening stench of the flowers rose up to fill my mouth and slither down my throat like perfumed poison. For a moment, I was back there, back with the roses, back in the shadows, beaten and bloody and wondering how I was going to survive what was coming next—")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“Gin? Are you okay?” Owen asked. “You look like you’re somewhere far away right now.”")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am,” I said in a distracted voice, still seeing things that he couldn’t, memories of another time, another place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another man.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Owen reached over and put his hand on top of mine. “Do you want to tell me about it?” he asked in a soft voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His touch broke the spell that the roses had cast on me, and I pulled myself out of my memories and stared at him. Owen looked back at me, his violet eyes warm with care, concern, and worry. It always surprised me to see those feelings reflected in his face, especially since we’d almost called it quits for good a few months ago. But we were back together and stronger than ever now. More important, he deserved to know about this. He deserved to know why I am the way I am—and who had helped make me this way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I gestured for him to take his seat on the stool again, while I laid the dark blue rose back down in the box with the others. I kept the card in my hand, though, my thumb tracing over the words again and again. Then I sat down on my own stool, leaned my elbows on the counter, and looked at Owen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Get comfortable,” I said. “Because it’s a long story. Funny enough, it all begins with a girl—a stupid, arrogant girl who thought that she could do no wrong . . .”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c53c630","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0